import React, { Component } from 'react';
import FileUploader from './../../../commons/FileUploader.js';
import DownloadFile from './../../../commons/DownloadFile.js';
import CONF from '../../../config/config.js';
export default class RequestLiquidation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		}
	}

	handleClickListItem = () => {
    	this.setState({ open: true });
  	};

  	handleClose = () => {
  		this.setState({ open: false });
  	}
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Request Liquidation
					</div>
					<div>
						<DownloadFile title="Download Request Liquidation Template" url="ingest/inventory/transfer/item/template"/>
					</div>
					<div className="top-thirty">
						<FileUploader url="ingest/inventory/liquidation/request" fileSizeLimit={CONF.FILE_SIZE_LIMIT_FOR_LIQUIDATION_INGESTION_IN_BYTES} />
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/Liquidation/Components/RequestLiquidation.js